import { MdDashboard, MdSearch } from 'react-icons/md';
import { useLocation } from 'react-router';

import { Sidebar } from '../../../../shared/components';
import { PATHS } from '../../../../shared/constants';
import { useDashboards } from '../../context';
import { DashboardsSidebarLink } from './dashboards-sidebar-link.component';

export const DashboardsSidebar = () => {
  const { pathname } = useLocation();
  const isSearchPath = pathname === PATHS.DashboardsSearch;
  const { categories } = useDashboards();

  return (
    <Sidebar
      heading="Dashboards"
      filterLinks={
        <div className="p-2 border-b border-gray-100">
          <DashboardsSidebarLink
            title="Search Workbooks"
            path={PATHS.DashboardsSearch}
            isSelected={isSearchPath}
            icon={MdSearch}
          />
        </div>
      }
    >
      <ul className="p-2">
        {categories.map((category) => {
          const isSelected = pathname.startsWith(
            `${PATHS.Dashboards}/${category}`
          );
          return (
            <li key={category}>
              <DashboardsSidebarLink
                title={category}
                path={`${PATHS.Dashboards}/${category}`}
                isSelected={isSelected}
                icon={MdDashboard}
              />
            </li>
          );
        })}
      </ul>
    </Sidebar>
  );
};
